import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "knudetilgang",
  "use": "knudetilgang-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" id=\"knudetilgang\"><path d=\"M26.08 8.87v1h-4.66a8.07 8.07 0 0 0-13 0H3.87v-1H1.62v9.72h2.07v-1h3.7a8.08 8.08 0 0 0 15.08 0h3.43v1h2.24V8.87z\" fill=\"#6d6e71\" stroke=\"#6d6e71\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\".5\" /><circle cx=\"21.63\" cy=\"15.15\" r=\"6.87\" fill=\"#76ae42\" /><path d=\"M22.55 16.06v2.72h-1.84v-2.72h-2.8v-1.83h2.8v-2.72h1.84v2.72h2.79v1.83z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/knudetilgang.svg
// module id = 8WfM
// module chunks = 1